import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (this.element.value.length > 0) {
      this.element.focus()
      this.element.setSelectionRange(this.element.value.length, this.element.value.length)
    }
  }

  submit() {
    clearTimeout(this._timeout)

    this._timeout = setTimeout(() => {
      this.element.form.requestSubmit()
    }, 300)
  }
}
